export const en = {
  level: "Level",
  readMore: "Read more",
  search: "Search",
  back: "Back",
};
